import CacheStore from 'bz-utilities/modules/stores/cached-map-store';
import { computed } from 'mobx';
import { createTransformer } from 'mobx-utils';
import type { GeneralPractitionerResponse, PractitionerLocation } from '../../api.dtos';

class PractitionerStore extends CacheStore<GeneralPractitionerResponse> {
  ByLocation = createTransformer((locationId: number) => {
    let res = this.All.filter((x) => x.locationIds.includes(locationId));
    return res;
  });

  ActivePractitionersByLocation = createTransformer((locationId: number) => {
    let res = this.Current.filter((x) => x.locationIds.includes(locationId));
    return res;
  });

  ByStatus = createTransformer((status: number) => {
    let res = this.All.filter((x) => x.status === status);
    return res;
  });

  constructor() {
    super('practitioners');
  }

  public search(searchTerm: string = ''): GeneralPractitionerResponse[] {
    const lowerSearchTerm = searchTerm.toLowerCase();
    return this.Current.filter(
      (room) =>
        room?.locationName?.toLowerCase().includes(lowerSearchTerm) ||
        room?.fullName?.toLowerCase().includes(lowerSearchTerm)
    );
  }

  @computed get Current() {
    return this.All.filter((x) => x.status === 1 || x.status === 2); // licensed or pay as you go
  }

  @computed get Licensed() {
    return this.All.filter((x) => x.status === 2); // licensed only
  }
}
export class PractitionerLocationStore extends CacheStore<PractitionerLocation> {
  constructor() {
    super('practitionerLocations');
  }
}

export default PractitionerStore;
